export enum CustomPanelTypeShape {
    Panel = 1,

    Corner = 2,

    ZShape = 3,
}

export enum CustomPanelTypeStatus {
    Created = 0,

    PreviewReady = 1,

    Published = 2,

    Failed = 3,
}

export interface ICustomPanelTypeBase {
    id: string;
    name: string;
    status: CustomPanelTypeStatus;
    offset: THREE.Vector3;
    height: number;
    bubbleUrl: string | null;
    thumbnailUrl: string | null;
    isSelected?: boolean;
}

export interface ICustomPanelType extends ICustomPanelTypeBase {
    length: number;
    shapeType: CustomPanelTypeShape.Panel;
}

export interface ICustomCornerType extends ICustomPanelTypeBase {
    leftWingLength: number;
    rightWingLength: number;
    angle: number;
    shapeType: CustomPanelTypeShape.Corner;
}

export interface ICustomZShapeType extends ICustomPanelTypeBase {
    leftWingLength: number;
    shelfLength: number;
    rightWingLength: number;
    angle1: number;
    angle2: number;
    shapeType: CustomPanelTypeShape.ZShape;
}

export type CustomPanelType = ICustomPanelType | ICustomCornerType | ICustomZShapeType;
export type CustomTypeArray = ICustomPanelType[] | ICustomCornerType[] | ICustomZShapeType[];

export interface ICustomPanelTypeCreatedResponse {
    id: string;
    uploadUrl: string;
}
